
export { ShoppingBagButton } from "/codebuild/output/src3838206175/src/packages/shared-components/src/components/ShoppingBagButton/index.ts"